var colspan = 'var(--xkjjsv1)';
var columns = 'var(--xkjjsv0)';
var group = 'xkjjsvf';
var groupAlt = 'xkjjsvl';
var input = 'xkjjsve xkjjsvc _14wijgr9';
var inputAlt = 'xkjjsvk xkjjsvi _14wijgr9';
var root = 'xkjjsvd xkjjsvc';
var rootAlt = 'xkjjsvj xkjjsvi';
var size = {md:'xkjjsva',lg:'xkjjsvb'};

export { colspan, columns, group, groupAlt, input, inputAlt, root, rootAlt, size };
//# sourceMappingURL=input.css.js.map
